<template>
  <div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      type="index"
		      label="ID"
		      align="center"
		      width="120"
		      :index="handlerSerial"
        >
		    </el-table-column>
        <el-table-column
          prop="user_name"
          label="客户联络人"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="user_mobile"
          label="联络人电话"
          align="center"
        >
        </el-table-column>
        <el-table-column
		      prop="type"
		      label="意向类型"
		      align="center"
        >
		    </el-table-column>
        <el-table-column
          prop="content"
          label="意向描述"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="提交时间"
          align="center"
        >
        </el-table-column>
		  </el-table>
		  <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonPagination from '@/components/CommonPagination';
import { getConsultList } from '@/api/consult';

export default {
  name: 'casemanage',
  data() {
  	return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getConsultList();
  },
  components: {
     CommonPagination
  },
  methods: {
  	handelPagesizeChange(size) {
      this.page_size = size;
      this._getConsultList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this._getConsultList();
  	},
    handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
     async _getConsultList() {
       let postData = {
         page_index: this.page_index,
         page_size: this.page_size
       }
       const { data, status } = await getConsultList(postData);
       if (status !== 200) return
       this.tableData = data.data;
       this.total = data.total;
       console.log(data, 'dataaaaa')
     }
  }
}
</script>

<style lang="less" scoped>

.table-wrap {
	margin-top: 40px;
}

</style>
